// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BulbOutlinedSvg from "@fishx/icons-svg/es/asn/BulbOutlined";
import FishxIcon from '../components/FishxIcon';

var BulbOutlined = function BulbOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BulbOutlinedSvg
  }));
};

BulbOutlined.displayName = 'BulbOutlined';
export default React.forwardRef(BulbOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BulbOutlined.js
// module id = 2136
// module chunks = 0